<script>
import api from "../api/api"

export default {
  name: "DikeTrajectoryUploadFileMixin",
  data: () => ({
    fileName: null,
    fieldNames: [],
    fieldName: null,
    loadingField: false,
  }),
  methods: {
    async uploadFile() {
      this.uploading = true
      const formData = new FormData();
      const file = this.fileName;
      formData.append("file", file, file.name);
      formData.append("field", this.fieldName);
      try {
        await this.upload(formData)
        this.$emit('continue')
      } catch (e) {
        console.log(e)
        this.uploading = false
      }
      this.uploading = false
    },
    resetSelectField: function () {
      this.loadingField = false
      this.fieldNames = []
      this.fieldName = null
    },
    async fetchGeometryFieldNames(baseUrl) {
      this.loadingField = true
      const formData = new FormData();
      if (!this.fileName) {
        return this.resetSelectField();
      } else {
        const file = this.fileName;
        formData.append("file", file, file.name);
        await api
            .post(
                `/${baseUrl}/get_field_names/`,
                formData
            )
            .then((response) => {
              this.fieldNames = response.data
            })
            .catch((error) => {
              console.log(error)
              this.loadingField = false
            });
        this.loadingField = false
      }

    }
  }
}
</script>

